import { push } from 'connected-react-router';

const redirectMiddleware = (store) => (next) => (action) => {
  const { redirect } = action;
  const { type, error } = action;

  if (type?.includes('_FAIL') && [401, 402].includes(error?.status)) {
      store.dispatch(push('/'));
  }

  if (!redirect || Array.isArray(type)) {
    return next(action);
  }

  if (redirect.success && type?.endsWith('_SUCCESS')) {
      store.dispatch(push(redirect.success));
  }

  if (redirect.fail && type?.endsWith('_FAIL')) {
      store.dispatch(push(redirect.fail));
  }

  return next(action);
};

export default redirectMiddleware;
